import ImagemProduto from '@/components/feature/ImagemProduto';
import Apertavel from '@/components/movimento/Apertavel';
import NumeroAnimado from '@/components/movimento/NumeroAnimado';
import { OURO } from '@/pages/loja/identidade';
import type { ItemCarteira } from '@/pages/loja/types';

interface Props {
  item: ItemCarteira;
  aoRetirar: () => void;
}

// Um botão grande por produto: foto à esquerda, nome em negrito e a
// quantidade disponível em número grande DOURADO à direita. Tocar abre a folha
// de retirada com este produto já no máximo. Cartão escuro, borda clara.
export default function ItemFicha({ item, aoRetirar }: Props) {
  // Nada disponível para retirar agora: ou já saiu tudo, ou está preso num vale.
  const apagado = item.disponivel === 0;
  const noVale = item.em_vale > 0;

  const detalhe = apagado
    ? noVale
      ? `${item.em_vale} no vale`
      : 'tudo retirado'
    : [
        `de ${item.quantidade}`,
        item.retirada > 0 ? `${item.retirada} já retirada` : null,
        noVale ? `${item.em_vale} no vale` : null,
      ]
        .filter(Boolean)
        .join(' · ');

  return (
    <Apertavel
      onClick={aoRetirar}
      disabled={apagado}
      className={`flex min-h-[76px] w-full items-center gap-3 rounded-[16px] border p-3 text-left transition-colors duration-200 ${
        apagado
          ? 'cursor-default border-white/[0.07] bg-white/[0.02] opacity-55'
          : 'cursor-pointer border-white/10 bg-white/[0.05] hover:border-white/25 hover:bg-white/[0.08]'
      }`}
    >
      <ImagemProduto
        imagemUrl={item.imagem_url}
        imagemSlug={item.imagem_slug}
        emoji={item.emoji}
        nome={item.produto}
        tamanho="media"
      />

      <span className="min-w-0 flex-1">
        <span className="block truncate text-[16px] font-semibold leading-snug text-white">
          {item.produto}
        </span>
        <span
          className={`mt-0.5 block text-[12px] ${
            apagado ? 'text-white/40' : noVale ? 'text-warning-300' : 'text-white/50'
          }`}
        >
          {detalhe}
        </span>
      </span>

      <span
        className={`flex h-[52px] w-[52px] shrink-0 items-center justify-center rounded-[14px] border text-[24px] font-extrabold tabular-nums ${
          apagado ? 'border-white/10 text-white/35' : 'border-white/15'
        }`}
        style={apagado ? undefined : { background: 'rgba(232,200,119,0.12)', color: OURO }}
      >
        <NumeroAnimado valor={String(item.disponivel)} />
      </span>
    </Apertavel>
  );
}